import type { FunctionComponent } from 'react';
import React from 'react';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { Logo } from '../../../../../logo/Logo';
import { PlusIcon } from '../../../../../icon/plus_icon/PlusIcon';

interface HeaderLogoProps {
  className?: string;
  jerryLogoGrey?: boolean;
  subHeaderText?: string;
  partnerLogo?: JSX.Element;
  logosSameLine?: boolean;
  noJerryLogo?: boolean;
  mainPartnerLogo?: boolean;
}

/**
 * Container for the logo section on app header.
 * Render either the default logo or custom logo.
 */
const UnstyledHeaderLogo: FunctionComponent<HeaderLogoProps> = ({
  className,
  jerryLogoGrey,
  subHeaderText,
  partnerLogo,
  logosSameLine,
  mainPartnerLogo = false,
}) => {
  return (
    <div className={className}>
      <Box display={logosSameLine ? 'flex' : undefined} alignItems={logosSameLine ? 'center' : undefined}>
        {!mainPartnerLogo ? <Logo color={jerryLogoGrey ? 'grey' : undefined} /> : partnerLogo}

        <Box display="flex" alignItems="center">
          {/* Render 'subHeaderText' as text*/}
          {subHeaderText && (
            <Typography id="topNavSubText" variant="subtitle1" align="center" className="subHeaderText">
              {subHeaderText}
            </Typography>
          )}

          {logosSameLine && (
            <Box ml={1} mr={1}>
              <PlusIcon />
            </Box>
          )}
          {!mainPartnerLogo && partnerLogo}
        </Box>
      </Box>
    </div>
  );
};

export const HeaderLogo = styled(UnstyledHeaderLogo)`
  .subHeaderText {
    font-size: 1rem;
    color: #6b7a86;
    margin-right: 0.312rem;
  }
`;
